var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupBuying f16" },
    [
      _c("div", { staticClass: "lin_15 f16 gray_3 fb" }, [
        _vm._v("\n      新增商品口碑视频\n    ")
      ]),
      _c("div", { staticClass: "box20" }),
      _c("el-button", { on: { click: _vm.cancle } }, [_vm._v("< 返 回")]),
      _c("div", { staticClass: "box20" }),
      _c("p", { staticClass: "ps_main_head" }, [
        _vm._v(
          "视频上传：仅支持mp4格式视频文件,建议视频时间在30s以内,单个视频大小不超过50m"
        )
      ]),
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.activityDtl,
                "label-width": "140px",
                "label-suffix": "："
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "本地上传" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "mar10-r",
                      attrs: {
                        action: _vm.env.VUE_APP_fileserver + "persistentUpload",
                        "file-list": _vm.activityDtl.kbVlog.videoList,
                        "on-success": _vm.uploadSuccess,
                        "before-upload": _vm.uploadBefore,
                        "show-file-list": false
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-column justify-center bg-f5 pointer items-center img radius5"
                        },
                        [
                          _c("img", {
                            staticClass: "block",
                            attrs: { src: require("./img/pc.png") }
                          }),
                          _c("div", { staticClass: "mar5-t f12 gray9" }, [
                            _vm._v("本地上传")
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "手机上传" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-column justify-center bg-f5 pointer items-center img mar10-r radius5",
                    on: { click: _vm.mobUpload }
                  },
                  [
                    _c("img", {
                      staticClass: "block",
                      attrs: { src: require("./img/pc.png") }
                    }),
                    _c("div", { staticClass: "mar5-t f12 gray9" }, [
                      _vm._v("手机上传")
                    ])
                  ]
                )
              ]),
              _c("el-form-item", { attrs: { label: "预览" } }, [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap" },
                  _vm._l(_vm.activityDtl.kbVlog.videoList, function(
                    item,
                    index
                  ) {
                    return _c("div", { key: index, staticClass: "mar20-r" }, [
                      _c(
                        "div",
                        { staticClass: "video-upload-info-container " },
                        [
                          _vm.isVideo(item.videoUrl)
                            ? _c("div", { staticClass: "video-box" }, [
                                _c(
                                  "video",
                                  {
                                    staticClass: "video-player",
                                    attrs: { src: item.videoUrl, controls: "" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    您的浏览器不支持视频播放\n                  "
                                    )
                                  ]
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-circle-close delete-video-icon",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.del(index)
                                    }
                                  }
                                })
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  type: "text",
                                  maxlength: "20",
                                  placeholder: "请输入视频标题(至多20字)"
                                },
                                model: {
                                  value: item.videoRemarks,
                                  callback: function($$v) {
                                    _vm.$set(item, "videoRemarks", $$v)
                                  },
                                  expression: "item.videoRemarks"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "box20" }),
          _c("div", { staticClass: "ps_footer t_center" }, [
            _c(
              "span",
              {
                staticClass: "dialog-footer ",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: _vm.disabled },
                    on: { click: _vm.confirmKbVlog }
                  },
                  [_vm._v("确 认")]
                ),
                _c("el-button", { on: { click: _vm.cancle } }, [
                  _vm._v("取 消")
                ])
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "手机扫码上传",
                visible: _vm.mobUploadVisible,
                width: "224px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.mobUploadVisible = $event
                }
              }
            },
            [
              _c("canvas", {
                ref: "qrCodeCanvas",
                attrs: { width: "250", height: "250" }
              }),
              _c("div", { staticClass: "text-center" }, [
                _vm._v("支持微信和智农通")
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }